import React, { Children } from 'react'
import styled from 'styled-components'
import { CONSTS } from './_constants'
type SpinProps ={
    className?: string,
    active : boolean,
    children?: any
}
const SpinComponent = (props: SpinProps)=>(
    <div className={`${props.className} ${props.active && "active"}`}>
        {props.children}
    </div>
)
const Spin = styled(SpinComponent)`
    position: relative;
    &::after{
        position: absolute;
        content: '';
        left:0;
        top:0;
        right:0;
        bottom: 0;
        background: ${CONSTS.colors.greyLighter};
        opacity: 0;
        pointer-events: none;
        transition: opacity .25s;
    }
    &.active{
        &::after{
            opacity: .7;
            pointer-events: all;
        }
    }

`;

export default Spin;